
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6UYek", function(module, exports) {

var $fbcPJ = parcelRequire("fbcPJ");


var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $fD0Uz = parcelRequire("fD0Uz");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$var$getLegacyApolloError = (error)=>{
    if (!('errors' in error) || !Array.isArray(error.errors)) return undefined;
    const firstError = error.errors[0];
    return firstError && typeof firstError === 'object' ? firstError : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorMessage = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('message' in firstError)) return undefined;
    return typeof firstError.message === 'string' ? firstError.message : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('extensions' in firstError)) return undefined;
    const { extensions: extensions } = firstError;
    if (!extensions || typeof extensions !== 'object' || !('statusCode' in extensions)) return undefined;
    return typeof extensions.statusCode === 'number' ? extensions.statusCode : undefined;
};
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = (subscribers[delta] ?? []).filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            const subscribersForDelta = subscribers[delta];
            if (subscribersForDelta) subscribersForDelta.forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $fbcPJ.default), {
        variables: {
            id: id,
            __extensions: extensions
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(data ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        interopApolloAggClient: true,
        __callerPackage__: "@confluence/graphql"
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || $da160e8fa3112de6$var$getLegacyApolloErrorMessage(error) || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode(error);
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("fbcPJ", function(module, exports) {
/**
 * @generated SignedSource<<c3d204b8cdf61b7b48be93a59878a242>>
 * @relayHash ea2b205ca41661c4d9e75a2c80bfd1c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1544e91e1f726342c809416076aa298d38dd5af242cabac4b6c9a623bc409d20
const $31174e902ea6e4b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "version"
    }, v6 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v7 = [
        v4 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v10 = [
        v9 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "confVersion"
    }, v12 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "inlineCommentType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "adfBodyContent"
    }, v15 = {
        "kind": "ScalarField",
        "name": "markerRef"
    }, v16 = {
        "kind": "ScalarField",
        "name": "publishVersionNumber"
    }, v17 = {
        "kind": "ScalarField",
        "name": "from"
    }, v18 = {
        "kind": "ScalarField",
        "name": "to"
    }, v19 = {
        "kind": "ScalarField",
        "name": "pos"
    }, v20 = {
        "kind": "ScalarField",
        "name": "annotationType"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v3 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "replies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "pageCommentType"
    }, v24 = [
        v3 /*: any*/ ,
        v12 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "emojiId"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "contentStateUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "emojiTitleUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "pageTitlePropertyUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "coverPictureDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "emojiTitleDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "contentStateDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCoverPictureWidthUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureWidthUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "coverPictureWidth"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageBlogified",
                    "kind": "LinkedField",
                    "name": "pageBlogified",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blogTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "converterDisplayName"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceEmbedUpdated",
                    "kind": "LinkedField",
                    "name": "embedUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isBlankStateUpdate"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageMigrated",
                    "kind": "LinkedField",
                    "name": "pageMigrated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEligibility"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentRestrictionUpdated",
                    "kind": "LinkedField",
                    "name": "contentRestrictionUpdated",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluencePageMoved",
                    "kind": "LinkedField",
                    "name": "pageMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldParentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldPosition"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceAlias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceAlias"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageUpdated",
                    "kind": "LinkedField",
                    "name": "pageUpdated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "trigger"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceWorkflowApplicationChanged",
                    "kind": "LinkedField",
                    "name": "workflowApplicationChanged",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "changeType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newWorkflowStatusId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        v5 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceMarkdownModeUpdated",
                    "kind": "LinkedField",
                    "name": "markdownModeUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isMarkdownMode"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentUpdatedWithTemplate",
                    "kind": "LinkedField",
                    "name": "contentUpdatedWithTemplate",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "inlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceRendererInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "rendererInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "editorInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUpdated",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentDeleted",
                    "kind": "LinkedField",
                    "name": "inlineCommentDeleted",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentResolved",
                    "kind": "LinkedField",
                    "name": "inlineCommentResolved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentResolveProperties",
                            "kind": "LinkedField",
                            "name": "inlineResolveProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolved"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedByDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedFriendlyDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedUser"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "inlineText"
                        },
                        v15 /*: any*/ ,
                        v22 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUnresolved",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentReattached",
                    "kind": "LinkedField",
                    "name": "inlineCommentReattached",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentUpdated",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentResolved",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentReopened",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceSchedulePublished",
                    "kind": "LinkedField",
                    "name": "schedulePublished",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "publishTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventType"
                        },
                        v11 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentAccessRequested",
                    "kind": "LinkedField",
                    "name": "contentAccessRequested",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentAccessDecisionMade",
                    "kind": "LinkedField",
                    "name": "contentAccessDecisionMade",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "decision"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionAdded",
                    "kind": "LinkedField",
                    "name": "inlineReactionAdded",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "newHighlight"
                        },
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stepType"
                                }
                            ]
                        },
                        v16 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionRemoved",
                    "kind": "LinkedField",
                    "name": "inlineReactionRemoved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionHighlightDeleted",
                    "kind": "LinkedField",
                    "name": "inlineReactionHighlightDeleted",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "ea2b205ca41661c4d9e75a2c80bfd1c5",
            "id": "1544e91e1f726342c809416076aa298d38dd5af242cabac4b6c9a623bc409d20",
            "metadata": {},
            "name": "SubscriptionsContextProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},markdownModeUpdated{isMarkdownMode,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename},inlineReactionAdded{commentId,markerRef,emojiId,newHighlight,step{from,to,pos,mark{attrs{annotationType,id},type},stepType},publishVersionNumber,__typename},inlineReactionRemoved{commentId,markerRef,emojiId,__typename},inlineReactionHighlightDeleted{commentId,markerRef,__typename}}}"
        }
    };
}();
$31174e902ea6e4b2$var$node.hash = "efc034f232cec513c997752add52e641";
var $31174e902ea6e4b2$export$2e2bcd8739ae039 = $31174e902ea6e4b2$var$node;
module.exports["default"] = $31174e902ea6e4b2$export$2e2bcd8739ae039;

});

parcelRegister("fD0Uz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7hXu9 = parcelRequire("7hXu9");


var $irOoi = parcelRequire("irOoi");


var $3e6Uc = parcelRequire("3e6Uc");


var $iffSy = parcelRequire("iffSy");


var $422HI = parcelRequire("422HI");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

const $c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode = (subscription)=>typeof subscription === 'function' || subscription.kind !== 'Document';
const $c7f06d7e4ea271ae$var$isFormattedExecutionResult = (response)=>Boolean(response && typeof response === 'object' && ('data' in response || 'errors' in response));
const $c7f06d7e4ea271ae$var$isSubscriptionData = (response)=>!$c7f06d7e4ea271ae$var$isFormattedExecutionResult(response);
const $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions = (response)=>{
    if (response == null) return {
        data: undefined,
        extensions: undefined
    };
    if ($c7f06d7e4ea271ae$var$isSubscriptionData(response)) return {
        data: response,
        extensions: undefined
    };
    return {
        data: response.data ?? undefined,
        extensions: response.extensions
    };
};
const $c7f06d7e4ea271ae$export$4966ff7f324f6363 = (response)=>{
    const { data: data, extensions: extensions } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
    return {
        ...extensions ? {
            extensions: extensions
        } : {},
        subscriptionData: {
            data: data,
            loading: false,
            ...extensions ? {
                extensions: extensions
            } : {}
        }
    };
};
const $c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment = ()=>{
    const isProduction = true;
    const isCloudProduction = false;
    const isCloudStaging = false;
    if (isProduction || isCloudProduction || isCloudStaging) return false;
    const isTest = false;
    const isDevelopment = false;
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    return isTest || isDevelopment || isLocalhost;
};
const $c7f06d7e4ea271ae$export$1bed67b955596e29 = (forceRelay)=>{
    if (!$c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment()) return false;
    window.__TEST_ONLY_FORCE_RELAY_MODE__ = forceRelay;
    return true;
};
function $c7f06d7e4ea271ae$export$275462b87cef6610(subscription, options) {
    const forceRelayMode = window.__TEST_ONLY_FORCE_RELAY_MODE__;
    const shouldUseRelay = forceRelayMode || (0, $iffSy.isRelayEnabled)(options?.__callerPackage__);
    if (shouldUseRelay) {
        if (!$c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode(subscription)) throw new Error('[Relay migration] useSubscriptionInterop Relay mode requires graphql tag');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options);
    } else {
        const { interopApolloAggClient: interopApolloAggClient, extensions: extensions, ...apolloOptions } = options ?? {};
        // Apollo v2's `useSubscription` does not forward a per-call `context` option down
        // to the WebSocket link, so we smuggle `extensions` through `variables.__extensions`.
        // `AttachExtensionsLink` strips it back out and re-attaches it to the operation
        // context, which `GraphQLWSLink.request` then sets on the wire payload.
        const variables = extensions !== undefined ? {
            ...apolloOptions.variables ?? {},
            __extensions: extensions
        } : apolloOptions.variables;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $7hXu9.useSubscription)((0, $86okN.toDocumentNode)(subscription), {
            ...apolloOptions,
            variables: variables,
            ...interopApolloAggClient ? {
                client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
            } : {}
        });
    }
}
const $c7f06d7e4ea271ae$var$toApolloErrorInterop = (error)=>new (0, $422HI.ApolloErrorInterop)({
        networkError: error instanceof Error ? error : new Error(String(error))
    });
function $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options) {
    const environment = (0, $irOoi.useRelayEnvironment)();
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [loading, setLoading] = (0, $42omo.useState)(!options?.skip);
    const disposableRef = (0, $42omo.useRef)(null);
    const callbacksRef = (0, $42omo.useRef)(options);
    callbacksRef.current = options;
    const skip = options?.skip;
    const variables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__);
    const extensions = (0, $iF5wn.useMemoObj)(options?.extensions, options?.__callerPackage__);
    (0, $42omo.useEffect)(()=>{
        if (skip) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        setData(undefined);
        try {
            disposableRef.current = (0, $3e6Uc.requestSubscription)(environment, {
                subscription: subscription,
                variables: variables,
                // `RelayWebSocketSubscriptionHandler` reads `cacheConfig.metadata.extensions`
                // and attaches them to the WS payload's `extensions` field.
                // cacheConfig is always set because useMemoObj coerces undefined → {}, so any
                // guard on `extensions` would always evaluate the same way. The consumer
                // (RelayWebSocketSubscriptionHandler) ignores an empty extensions object.
                cacheConfig: {
                    metadata: {
                        extensions: extensions
                    }
                },
                onNext: (response)=>{
                    const { data: responseData } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
                    setData(responseData);
                    setError(undefined);
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionData?.($c7f06d7e4ea271ae$export$4966ff7f324f6363(response));
                },
                onError: (err_0)=>{
                    setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err_0));
                    setLoading(false);
                },
                onCompleted: ()=>{
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionComplete?.();
                }
            });
        } catch (err) {
            setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err));
            setLoading(false);
        }
        return ()=>{
            if (!disposableRef.current) return;
            disposableRef.current.dispose();
            disposableRef.current = null;
        };
    }, [
        environment,
        subscription,
        variables,
        extensions,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSubscriptionInterop"] = $c7f06d7e4ea271ae$export$275462b87cef6610;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});


//# sourceMappingURL=PageContentRendererFabric.5bd1a1bc.js.map
